import React from 'react';
import { UsersIcon, BookCopyIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-tennis-dark text-white py-6 border-b border-white/10" data-id="element-272">
      <div className="max-w-6xl mx-auto px-4" data-id="element-273">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-white/10" data-id="element-274">
          <div className="flex flex-col items-center justify-center" data-id="element-275">
            <UsersIcon className="text-clay-orange mb-2" size={24} data-id="element-276" />
            <span className="font-display text-xl md:text-2xl" data-id="element-277">+500</span>
            <span className="text-sm text-gray-300 font-medium" data-id="element-278">
              profes confían
            </span>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-279">
            <BookCopyIcon className="text-clay-orange mb-2" size={24} data-id="element-280" />
            <span className="font-display text-xl md:text-2xl" data-id="element-281">12+6</span>
            <span className="text-sm text-gray-300 font-medium" data-id="element-282">
              Tomos + Bonus
            </span>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-283">
            <div className="flex text-ball-yellow mb-2" data-id="element-284">
              <StarIcon size={20} fill="currentColor" data-id="element-285" />
              <StarIcon size={20} fill="currentColor" data-id="element-286" />
              <StarIcon size={20} fill="currentColor" data-id="element-287" />
              <StarIcon size={20} fill="currentColor" data-id="element-288" />
              <StarIcon size={20} fill="currentColor" data-id="element-289" />
            </div>
            <span className="font-display text-xl md:text-2xl" data-id="element-290">4.9/5</span>
            <span className="text-sm text-gray-300 font-medium" data-id="element-291">
              calificación
            </span>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-292">
            <MapPinIcon className="text-clay-orange mb-2" size={24} data-id="element-293" />
            <span className="text-2xl mb-1" data-id="element-294">🇦🇷</span>
            <span className="text-sm text-gray-300 font-medium" data-id="element-295">Argentina</span>
          </div>
        </div>
      </div>
    </div>;
}